/**
 * <Email
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { Component } from 'react';
import classnames from 'classnames'
import validator from 'validator';
import Select from 'react-select';
import locale from './locale';

const options = [
  { value: '1', label: __('Monday', locale) },
  { value: '2', label: __('Tuesday', locale) },
  { value: '3', label: __('Wednesday', locale) },
  { value: '4', label: __('Thursday', locale) },
  { value: '5', label: __('Friday', locale) },
  { value: '6', label: __('Saturaday', locale) },
  { value: '7', label: __('Sunday', locale) }
];
export function validateWeekdateSelect(value) {
  if(!value || value.length<1){
    return {
      ok: false,
      failed: {
        because: ['required'],
        value
      }
    }
  }
}

class WeekdateSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: props.value,
    }
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    // const { onChange } = this.props;
    // const { selectedOptions } = this.state;
    // onChange(selectedOptions)
  }
  onChange(selectedOptions){
    this.setState({ selectedOptions });
    this.props.onChange(selectedOptions);
  }
  render() {
    const {
      value,
      onChange,
    } = this.props;
    const { selectedOptions } = this.state;
    return (
      <Select
        value={selectedOptions}
        onChange={this.onChange}
        options={options}
        multi={true}
        closeOnSelect={false}
      />
    );
  }
}

export default WeekdateSelect;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/WeekdateSelect/index.js